import React, { useState } from 'react';
import classNames from 'classnames';
import { USER_AVAILABILITY } from '../../forms/ProfileSettingsForm/config';
import { FormattedMessage } from '../../util/reactIntl';
import { ConditionalWrapper } from '../../util/common';
import { IconPenM } from '../../icons';
import { Tooltip } from '../../components';
import EditUserInfoModal from '../../forms/ProfileSettingsForm/EditUserInfoModal';
import css from './AvailabilityBadge.css';

const DEFAULT_AVAILABILITY_STATUS = 'notAvailable';

export default ({
    user,
    isPublic,
    helpTextAllowed = false,
    editAllowed = false,
    parentContainerRef,
    rootClassName,
    children,
    isConfirm = false,
    onLightBackground,
    modalId,
}) => {
    const [isEditModalOpen, setEditModalOpen] = useState(false);

    if (!user || !user.id) return null;

    const {
        displayName,
        publicData: { availabilityUpdatedAt, availabilityStatus = DEFAULT_AVAILABILITY_STATUS },
    } = user.attributes.profile;

    const noAvailabilityHasBeenSetYet = typeof availabilityUpdatedAt === 'undefined';

    const [firstName] = (displayName || '').split(' ');

    const userAvailabilityContent = (
        <>
            <p>
                <FormattedMessage
                    id={`ProfileSettingsPage.tooltipContentHeading-${availabilityStatus}${
                        isPublic ? '-public' : ''
                    }`}
                />
            </p>
            <p>
                <FormattedMessage
                    id={`ProfileSettingsPage.tooltipContentDesc-${availabilityStatus}${
                        isPublic ? '-public' : ''
                    }`}
                    values={{ userName: firstName }}
                />
            </p>
        </>
    );

    return (
        <>
            <ConditionalWrapper
                condition={helpTextAllowed}
                wrapper={children => (
                    <Tooltip
                        tooltipClassName={css.tooltip}
                        rootClassName={css.tooltipRoot}
                        content={userAvailabilityContent}
                        parentContainerRef={parentContainerRef}
                    >
                        {children}
                    </Tooltip>
                )}
            >
                <div
                    className={classNames(css.root, {
                        [css.editAllowed]: editAllowed,
                        [css.lightRoot]: !!onLightBackground,
                        [rootClassName]: !!rootClassName,
                    })}
                    /**
                     * Rider Listing Cards for SP:
                     * onClick & onTouchStart preventDefault & stopPropagation are called
                     * in order to prevent navigation to profile page on badge click;
                     */
                    onClick={e => {
                        if (!editAllowed) {
                            e.preventDefault();
                            e.stopPropagation();
                            return;
                        }

                        setEditModalOpen(true);
                    }}
                >
                    <code className={classNames(css.availabilityStatus, css[availabilityStatus])} />
                    <FormattedMessage
                        id={`ProfileSettingsPage.availability-${availabilityStatus}`}
                    />
                    {editAllowed && (
                        <code className={css.editPencilIcon}>
                            <IconPenM />
                            {children}
                        </code>
                    )}
                </div>
            </ConditionalWrapper>
            {isEditModalOpen && (
                <EditUserInfoModal
                    isOpen
                    editSectionName={USER_AVAILABILITY}
                    currentUser={user}
                    modalParams={{ isConfirm: isConfirm || !noAvailabilityHasBeenSetYet }}
                    onClose={() => setEditModalOpen(false)}
                    modalId={modalId}
                />
            )}
        </>
    );
};
